import { http } from '../http/api'

/**
 * 检测是否为空
 */
export const isNull = (e) => {
  return e === undefined || e === 'undefined' || e == null || e === '' || e === 0
}

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 获取？号后面的参数
 */
export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 * 支付
 */
export const pay = id => {
  return new Promise((resolve, reject) => {
    http.post('/index.php?r=api/topayment', {id}).then((res) => {
      var params = JSON.parse(res.jsApiParameters)
      console.log(params, '我是支付取的参数')
      window.wx.config({
        debug: false,
        appId: params.appId,
        timestamp: params.timeStamp,
        nonceStr: params.nonceStr,
        signature: params.signature,
        jsApiList: ['chooseWXPay']
      })
      window.wx.ready(() => {
        window.wx.chooseWXPay({
          appId: params.appId,
          timestamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
          package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: params.paySign, // 支付签名
          success: (res) => {
            http.post('/index.php?r=api/orderquery', {id}).then(() => {
              resolve(res)
            })
          },
          complete: function (res) {
            // 接口调用完成时执行的回调函数，无论成功或失败都会执行。
          },
          fail: (res) => {
            // alert('我支付失败了')
            // reject(res)
          },
          cancel: (res) => {
            reject(res)
          }
        })
      })
      // window.wx.error((res) => {
      //   console.log(res.err_msg)
      // })
    })
  })
}

/**
 * 分享
 */
export const share = () => {
  return new Promise((resolve) => {
    http.post('/index.php?r=api/getwecatshareconfig', {url: window.location.href}).then((res) => {
      window.wx.config({
        debug: res.jsapiconfig.debug,
        appId: res.jsapiconfig.appId,
        timestamp: res.jsapiconfig.timestamp,
        nonceStr: res.jsapiconfig.nonceStr,
        signature: res.jsapiconfig.signature,
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
      })
      window.wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareAppMessage({// 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
          title: res.menushare.title, // 分享标题
          desc: res.menushare.desc, // 分享描述
          link: res.menushare.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.menushare.imgUrl, // 分享图标
          success: () => {

          }
        })
      })
      window.wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareTimeline({ // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
          title: res.menushare.title, // 分享标题
          link: res.menushare.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.menushare.imgUrl, // 分享图标
          success: () => {
            resolve()
          }
        })
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/util.js